/**
 * SandboxPage — Full sandbox management page.
 *
 * Composes SandboxLauncher, ApiKeySetup, and SandboxConfigEditor
 * into a responsive page layout.
 */
import { SandboxLauncher, ApiKeySetup, SandboxConfigEditor } from "@/components/sandbox";

export function SandboxPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Sandbox Management</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Launch, configure, and manage your AI coding sandbox container.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        {/* Left column: launcher + config */}
        <div className="space-y-6">
          <SandboxLauncher />
          <SandboxConfigEditor />
        </div>

        {/* Right column: API keys */}
        <div className="space-y-6">
          <ApiKeySetup />
        </div>
      </div>
    </div>
  );
}
